/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_TextInputs */

const en_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing was successful. Please verify the asset in Iconik before exiting.`)
};

const fr_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La publication a reussi. Veuillez verifier l'asset dans Iconik avant de quitter.`)
};

const de_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Veröffentlichung war erfolgreich. Bitte überprüfen Sie das Asset in Iconik, bevor Sie das Programm beenden.`)
};

const it_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione avvenuta con successo. Verifica la risorsa in Iconik prima di uscire.`)
};

const ru_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публикация прошла успешно. Пожалуйста, проверьте ресурс в Iconik перед выходом.`)
};

const es_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación exitosa. Verifique el recurso en Iconik antes de salir.`)
};

const zh_cn2_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布成功。请在退出前在 Iconik 中验证资产。`)
};

const ja_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開に成功しました。終了する前にIconikでアセットを確認してください。`)
};

const hi_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन सफल रहा। बाहर निकलने से पहले कृपया Iconik में एसेट को सत्यापित करें।`)
};

const pt_pt2_iconik_publish_success_text = /** @type {(inputs: Iconik_Publish_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A publicação foi concluída com sucesso. Verifique o arquivo no Iconik antes de sair.`)
};

/**
* | output |
* | --- |
* | "Publishing was successful. Please verify the asset in Iconik before exiting." |
*
* @param {Iconik_Publish_Success_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_text = /** @type {((inputs?: Iconik_Publish_Success_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_success_text(inputs)
	if (locale === "de") return de_iconik_publish_success_text(inputs)
	if (locale === "it") return it_iconik_publish_success_text(inputs)
	if (locale === "ru") return ru_iconik_publish_success_text(inputs)
	if (locale === "es") return es_iconik_publish_success_text(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_success_text(inputs)
	if (locale === "ja") return ja_iconik_publish_success_text(inputs)
	if (locale === "hi") return hi_iconik_publish_success_text(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_success_text(inputs)
	return en_iconik_publish_success_text(inputs)
});